import type { BaseQueryFn } from "@reduxjs/toolkit/query";

import instance from "../interceptor";
import { rejectionStatusOf } from "../rejectionStatus";
import { AxiosBaseQueryArgs, AxiosBaseQueryMeta } from "./types";

// Routes through the shared axios `instance`, not a raw `fetch` baseQuery, so
// CSRF injection and the 401/403 interceptor retries still apply.
export const axiosBaseQuery =
  (): BaseQueryFn<
    AxiosBaseQueryArgs,
    unknown,
    unknown,
    object,
    AxiosBaseQueryMeta
  > =>
  async ({ url, method = "get", data, params, unwrapResult = true }) => {
    try {
      const result = await instance({ url, method, data, params });
      return {
        data:
          unwrapResult === false
            ? result.data
            : (result.data?.result ?? result.data),
      };
    } catch (err) {
      return { error: err, meta: { status: rejectionStatusOf(err) } };
    }
  };
